import Comments from "../../components/Comments";
import { order } from "../SmartSearchParammeter";

export default async function CommentsSearchConfig(key) {
  return {
    description: "Comments",
    id: "comments",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <Comments searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["comments"] = value[0];
    }
  };
}
